import { formatCurrency } from '../../utils/formatNumbers';

const PriceAssetPricesCell = (params: any) => (
  <>
    {`${formatCurrency(params.row.from_price)} / ${formatCurrency(params.row.up_to_price)} / ${formatCurrency(params.row.avg_price)}`}
  </>
);

export default PriceAssetPricesCell;
